import store from '@/store'
import getCountryConfig from '@/common/config/country-config'

const currencys = getCountryConfig.currency.currency

const semverGte = require('semver/functions/gte')
/**
 * @name 版本对比大于等于，默认使用semver，semver无法对比开头是0的版本，比如1.3.00，所以再用数字判断
 * @param {String} targetVersion 要对比的版本号
 * @param {String} stableVersion 线上稳定的版本号
 * @returns {Boolean}
 */
export const versionSemverGte = (targetVersion, stableVersion) => {
  try {
    return semverGte(targetVersion, stableVersion)
  } catch (err) {
    return versionNumberJudge(targetVersion, stableVersion)
  }
}

/**
 * @name 变成数字判断版本号
 */
const versionNumberJudge = (targetVersion, stableVersion) => {
  try {
    const targetVersionNumber = +targetVersion.split('.').join('')
    const stableVersionNumber = +stableVersion.split('.').join('')
    return targetVersionNumber > stableVersionNumber || targetVersionNumber === stableVersionNumber
  } catch (err) {
    console.error(err)
    return true
  }
}

export function priceFixed(price) {
  const currentCurrency = store.state.currentShop.currency || 'default'
  const { isNeedFixed, rate } = currencys(currentCurrency)
  return isNeedFixed ? Number(price / rate).toFixed(2) : Number(price / rate)
}
